"use client";

import { Input } from "@/components/ui/input";
import { type ActiveFilter, type FilterFieldDef } from "./types";

export function FilterNumberValue({
  filter,
  field,
  onUpdate,
}: {
  filter: ActiveFilter;
  field: FilterFieldDef;
  onUpdate: (updated: ActiveFilter) => void;
}) {
  return (
    <div className="min-w-[72px] max-w-[120px]">
      <Input
        type="number"
        inputMode="numeric"
        variant="ghost"
        size="none"
        value={filter.value}
        onChange={(e) => onUpdate({ ...filter, value: e.target.value })}
        placeholder={field.placeholder ?? "0"}
        className="h-full w-full px-1.5 text-[13px] font-medium tabular-nums text-contrast/75 placeholder:text-contrast/25"
      />
    </div>
  );
}
